/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import { ContentZonesService } from '@sm360/widget-commons-core-services';

import CashPayment from 'commons-vehicle/Vehicle/components/Payment/CashPayment/CashPayment.jsx';
import Financing from 'commons-vehicle/Vehicle/components/Payment/Financing/Financing.jsx';
import Price from 'commons-vehicle/Vehicle/components/Payment/Price/Price.jsx';
import PaymentDetailRebate from 'commons-vehicle/Vehicle/components/Payment/PaymentDetail/PaymentDetailRebate.jsx';
import PurchaseMethodsConstantV25 from 'commons-vehicle/PurchaseMethodsV25/constants/purchaseMethodsV25.js';
import PurchaseMethodsModelV25 from 'commons-vehicle/PurchaseMethodsV25/models/PurchaseMethodsModelV25';

const PaymentDetail = ({
    forcedPurchaseMethod,
    isUsed,
    taxCodes,
    purchaseMethods,
    taxesDisclaimer,
    cashPurchaseOption,
    priceLoading,
    displayCreditRate,
}) => {
    const currentMethod = forcedPurchaseMethod || purchaseMethods.getSelectedPurchaseMethodValue();

    const tradeInAmount = purchaseMethods.tradeIn;

    const tradeIn =
        (tradeInAmount > 0 && (
            <PaymentDetailRebate
                amount={tradeInAmount}
                i18nKey="PAYMENTS_REBATES.TRADEIN"
                data={{ 'data-sr': 'TradeIn' }}
                iconClass="icon-refresh"
            />
        )) ||
        undefined;

    const modelElectricRebate = purchaseMethods.getElectricRebate();
    const electricRebate =
        (modelElectricRebate > 0 && (
            <PaymentDetailRebate
                amount={modelElectricRebate}
                i18nKey="PAYMENTS_REBATES.ELECTRIC_REBATE"
                data={{ 'data-sr': 'ElectricRebate' }}
                iconClass="icon-electric-vehicle"
            />
        )) ||
        undefined;

    let paymentMethod = null;

    const includedDisclaimerCzLocation = isUsed
        ? 'disclaimer.price.included.used.cash'
        : 'disclaimer.price.included.new';
    const includedDisclaimer = ContentZonesService.getContentZone('widget.commons', includedDisclaimerCzLocation)
        ? ContentZonesService.getContentZone('widget.commons', includedDisclaimerCzLocation).getValue()
        : '';

    const manufacturerRebatesAmount = purchaseMethods.getManufacturerRebates();

    const dealerRebatesAmount = purchaseMethods.getDealerRebate();

    const rebates =
        (manufacturerRebatesAmount > 0 && (
            <PaymentDetailRebate
                amount={manufacturerRebatesAmount}
                i18nKey={isUsed ? 'PAYMENTS_REBATES.USED_REBATE' : 'PAYMENTS_REBATES.MANUFACTURER_REBATE'}
                data={{ 'data-sr': 'Rebate' }}
                iconClass="icon-promo2"
            />
        )) ||
        undefined;

    const dealerRebates =
        (dealerRebatesAmount > 0 && (
            <PaymentDetailRebate
                amount={dealerRebatesAmount}
                i18nKey="PAYMENTS_REBATES.DEALER_REBATE"
                data={{ 'data-sr': 'Rebate' }}
                iconClass="icon-promo2"
                isUsed
            />
        )) ||
        undefined;

    if (currentMethod === PurchaseMethodsConstantV25.FINANCE || currentMethod === PurchaseMethodsConstantV25.LEASE) {
        paymentMethod = (
            <Financing
                purchaseMethods={purchaseMethods}
                taxCodes={taxCodes}
                isUsed={isUsed}
                rebates={rebates}
                dealerRebates={dealerRebates}
                electricRebate={electricRebate}
                loading={priceLoading}
                displayCreditRate={displayCreditRate}
            >
                {tradeIn}
            </Financing>
        );
    } else if (currentMethod === PurchaseMethodsConstantV25.CASH) {
        const msrp =
            purchaseMethods.cashPurchase?.retailDetails?.total || cashPurchaseOption?.retailDetails?.total || 0;
        const amountPrice = purchaseMethods.cashPurchase?.sellingPrice || cashPurchaseOption?.sellingPrice;

        const taxesExcludedDisclaimer = purchaseMethods.cashPurchase?.taxesDisclaimer;
        paymentMethod = (
            <div className="payment-summary-section">
                <CashPayment isUsed={isUsed} msrp={msrp} loading={priceLoading}>
                    <div>
                        {includedDisclaimer && (
                            <span className="payment-row disclaimer is-light sr-text">{includedDisclaimer}</span>
                        )}
                        <div className="payment-rebates">
                            {rebates}
                            {dealerRebates}
                            {electricRebate}
                        </div>
                    </div>
                </CashPayment>
                <Price
                    amount={amountPrice}
                    taxCodes={taxCodes}
                    taxesDisclaimer={taxesDisclaimer}
                    taxesExcludedDisclaimer={taxesDisclaimer || taxesExcludedDisclaimer}
                    isUsed={isUsed}
                    loading={priceLoading}
                />
            </div>
        );
    }
    return paymentMethod;
};

PaymentDetail.defaultTypes = {
    forcedPurchaseMethod: null,
    displayCreditRate: false,
};

PaymentDetail.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethodsModelV25),
    forcedPurchaseMethod: PropTypes.string,
    isUsed: PropTypes.bool.isRequired,
    taxCodes: PropTypes.string.isRequired,
    displayCreditRate: PropTypes.bool,
};

PaymentDetail.displayName = 'PaymentDetail';

export default PaymentDetail;
